import head from 'lodash.head';
import { CLEAR_RESULTS, FETCH_ITEM_LEVEL_DETAILS } from '../../actionTypes/shared/apiActionTypes';
import {
    actionStarted,
    actionSuccessfullyFinished,
    actionFinishedWithError,
} from '../../actionCreators';
import selectors from '../../../root/shared/root';

export const clearResults = () => ({ type: CLEAR_RESULTS });

export const fetchItemLevelDetails =
    (assessment, client, results = []) =>
    async (dispatch, getState) => {
        const state = getState();
        const enrollmentInfo = selectors.getEnrollmentInfo(state);
        dispatch(actionStarted(FETCH_ITEM_LEVEL_DETAILS.START));
        try {
            const { studentId } = head(results) || {};
            const responses = await Promise.all(
                results.map(result => client.getProbeDetails(enrollmentInfo, assessment, result)),
            );
            responses.forEach(response => {
                dispatch(
                    actionSuccessfullyFinished(FETCH_ITEM_LEVEL_DETAILS.SUCCESS, {
                        response,
                        studentId,
                    }),
                );
            });
        } catch (error) {
            dispatch(actionFinishedWithError(FETCH_ITEM_LEVEL_DETAILS.ERROR, { error }));
        }
    };
